import { axiosApiCall } from "../axios/customInstance";

export const sendEmail = async (send_to, subject, message) => {
  const url =
    "/send_email?send_to=" +
    send_to +
    "&subject=" +
    subject +
    "&message=" +
    message;

  try {
    const response = await axiosApiCall.post(url);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const requestPasswordReset = async (send_to) => {
  const url = "/request_reset?email=" + send_to;

  try {
    const response = await axiosApiCall.post(url);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const sendNewPassword = async (email, token, newPassword) => {
  const url =
    "/reset?email=" + email + "&token=" + token + "&newPassword=" + newPassword;

  try {
    const response = await axiosApiCall.post(url);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
